import { j as i, c as f } from "../../utils-BdNIfrGQ.js";
import * as o from "react";
import { c as b } from "../../index-UQQE3dtT.js";
import { u as k } from "../../index-0ioNhtNM.js";
import { u as m } from "../../index-CCKe-Mpx.js";
import { P as v } from "../../index-oiSd2zY3.js";
import { r as F } from "../../index-DXQlDdB3.js";
import { n as M } from "../../normalize-spacing-DY0KSpr_.js";
import { a as P } from "../../Avatar.styles-ocFXjGa8.js";
var $ = F();
function T() {
  return $.useSyncExternalStore(
    q,
    () => !0,
    () => !1
  );
}
function q() {
  return () => {
  };
}
var p = "Avatar", [H] = b(p), [V, x] = H(p), S = o.forwardRef(
  (a, e) => {
    const { __scopeAvatar: r, ...n } = a, [s, t] = o.useState("idle");
    return /* @__PURE__ */ i.jsx(
      V,
      {
        scope: r,
        imageLoadingStatus: s,
        onImageLoadingStatusChange: t,
        children: /* @__PURE__ */ i.jsx(v.span, { ...n, ref: e })
      }
    );
  }
);
S.displayName = p;
var L = "AvatarImage", h = o.forwardRef(
  (a, e) => {
    const { __scopeAvatar: r, src: n, onLoadingStatusChange: s = () => {
    }, ...t } = a, u = x(L, r), d = z(n, t), l = k((c) => {
      s(c), u.onImageLoadingStatusChange(c);
    });
    return m(() => {
      d !== "idle" && l(d);
    }, [d, l]), d === "loaded" ? /* @__PURE__ */ i.jsx(v.img, { ...t, ref: e, src: n }) : null;
  }
);
h.displayName = L;
var w = "AvatarFallback", N = o.forwardRef(
  (a, e) => {
    const { __scopeAvatar: r, delayMs: n, ...s } = a, t = x(w, r), [u, d] = o.useState(n === void 0);
    return o.useEffect(() => {
      if (n !== void 0) {
        const l = window.setTimeout(() => d(!0), n);
        return () => window.clearTimeout(l);
      }
    }, [n]), u && t.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ i.jsx(v.span, { ...s, ref: e }) : null;
  }
);
N.displayName = w;
function A(a, e) {
  return a ? e ? (a.src !== e && (a.src = e), a.complete && a.naturalWidth > 0 ? "loaded" : "loading") : "error" : "idle";
}
function z(a, { referrerPolicy: e, crossOrigin: r }) {
  const n = T(), s = o.useRef(null), t = n ? (s.current || (s.current = new window.Image()), s.current) : null, [u, d] = o.useState(
    () => A(t, a)
  );
  return m(() => {
    d(A(t, a));
  }, [t, a]), m(() => {
    const l = (_) => () => {
      d(_);
    };
    if (!t) return;
    const c = l("loaded"), g = l("error");
    return t.addEventListener("load", c), t.addEventListener("error", g), e && (t.referrerPolicy = e), typeof r == "string" && (t.crossOrigin = r), () => {
      t.removeEventListener("load", c), t.removeEventListener("error", g);
    };
  }, [t, r, e]), u;
}
var y = S, R = h, E = N;
const j = o.forwardRef(({ className: a, ...e }, r) => /* @__PURE__ */ i.jsx(
  y,
  {
    ref: r,
    className: f("relative flex shrink-0 overflow-hidden rounded-full", a),
    ...e
  }
));
j.displayName = y.displayName;
const I = o.forwardRef(({ className: a, ...e }, r) => /* @__PURE__ */ i.jsx(
  R,
  {
    ref: r,
    className: f("aspect-square h-full w-full", a),
    ...e
  }
));
I.displayName = R.displayName;
const C = o.forwardRef(({ className: a, ...e }, r) => /* @__PURE__ */ i.jsx(
  E,
  {
    ref: r,
    className: f("flex h-full w-full items-center justify-center rounded-full", a),
    ...e
  }
));
C.displayName = E.displayName;
const X = ({
  profileImage: a,
  fallback: e,
  spacing: r,
  size: n,
  accent: s,
  ...t
}) => /* @__PURE__ */ i.jsxs(
  j,
  {
    className: f(P({ size: n, accent: s }), M(r)),
    ...t,
    children: [
      /* @__PURE__ */ i.jsx(I, { src: a, alt: "" }),
      /* @__PURE__ */ i.jsx(C, { children: e })
    ]
  }
);
export {
  X as default
};
